
import {
  createFileRoute,
} from '@tanstack/react-router'

import {
  CustomerDetailPage,
} from '@/features/customers/pages/customer-detail-page'

export const Route = createFileRoute(
  '/_authenticated/customers/$customerId/detail',
)({
  component: function CustomerDetailRoute() {
    return <CustomerDetailPage />
  },
})
